(function () {
    'use strict';

    angular
        .module('app.paymentTemplates')
        .controller('PaymentTemplateListController', PaymentTemplateListController);

    PaymentTemplateListController.$inject = ['common', 'dataservice'];
    /* @ngInject */
    function PaymentTemplateListController(common, dataservice) {
        var vm = this;

        vm.title = 'Payment Templates';
        vm.displayedItems = [];
        vm.items = [];
        vm.refresh = refresh;
        vm.isLicenseValid = false;
        vm.isLoading = true;
        vm.licenseInfo = {};
        vm.isCollegeNet = common.userService.isCollegeNetApi();

        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItems(), getLicenseInfo()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
                vm.isLoading = false;
            }, function (error) { });
        }

        function getLicenseInfo() {
            return dataservice.getItems('api/Tenants/GetLicenseInfo').then(function (response) {
                vm.licenseInfo = response.data;
                vm.isLicenseValid = vm.licenseInfo.NumberOfPaymentTemplatesLicensed >= vm.licenseInfo.NumberOfPaymentTemplatesInUse;
                return vm.licenseInfo;
            }, function (error) { });
        }
     
        function getItems() {
            return dataservice.getItems('api/PaymentTemplates').then(function (response) {
                vm.items = response.data;
                vm.displayedItems = [].concat(vm.items);
                return vm.items;
            });
        }

        function refresh() {
            getItems();
        }
    }
})();
